import { trackMoveAction } from '../../../_common/client/tracking';

export const addMoveTrackingToAllReviewsButton = (rootElement: HTMLElement) => {
    const allReviewsButton = rootElement.querySelector('.js_cr_list-wrapper__all-review-button');
    if (allReviewsButton) {
        allReviewsButton.addEventListener('click', () => {
            trackMoveAction({ ot_PageCluster: ['Artikeldetailseite'], review_Navigation: ['bottom'] }, { name: 'click', features: [] });
        });
    }
};
